import { render, staticRenderFns } from "./CourseScheduleDetailsComponent.vue?vue&type=template&id=9db3f670"
import script from "./CourseScheduleDetailsComponent.vue?vue&type=script&lang=js"
export * from "./CourseScheduleDetailsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports